export default "__VITE_ASSET__C_FCSq$L__"